import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}products/ferry/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {

  /**
   * Retrieve a list of suppliers.
   *
   * @returns {AxiosPromise}
   */
  getSuppliers() {
    return conduit.get('suppliers');
  },

  /**
   * Retrieve a list of car types.
   *
   * @param supplier
   * @returns {AxiosPromise}
   */
  getCarTypes(supplier) {
    return conduit.get(`car-types/supplier/${supplier}`);
  },

  /**
   * Save a car type.
   *
   * @param carType
   * @returns {AxiosPromise}
   */
  saveCarType(carType) {
    return conduit.put('car-types', {
      carTypes: [
        carType,
      ],
    });
  },

  /**
   * Save a car type.
   *
   * @param supplierId
   * @param carType
   * @returns {AxiosPromise}
   */
  addCarType(supplierId, carType) {
    return conduit.post(`car-types/supplier/${supplierId}`, {
      carTypes: [
        carType,
      ],
    });
  },

  /**
   * Retrieve a list of routes
   *
   * @param supplier
   * @returns {AxiosPromise}
   */
  getRoutes(supplier) {
    return conduit.get(`routes/supplier/${supplier}`);
  },

  /**
   * Save a route.
   *
   * @param route
   * @returns {*}
   */
  saveRoute(route) {
    return conduit.put(`routes/route/${route.id}`, route);
  },

  /**
   * @param route
   * @returns AxiosPromise
   */
  getCheckInInformationForRoute(route) {
    return conduit.get(`routes/route/${route.id}/check-in-informations`);
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getRouteTextTags(routeId) {
    return conduit.get(`routes/route/${routeId}/texts/tags`);
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getRouteTexts(routeId) {
    return conduit.get(`routes/route/${routeId}/texts`);
  },

  /**
   * @param routeId
   * @param text
   * @returns {AxiosPromise}
   */
  createRouteText(routeId, text) {
    return conduit.post(`routes/route/${routeId}/texts`, text);
  },

  /**
   * @param routeId
   * @param textId
   * @param text
   * @returns {AxiosPromise}
   */
  updateRouteText(routeId, textId, text) {
    return conduit.put(`routes/route/${routeId}/texts/${textId}`, text);
  },

  /**
   * @param routeId
   * @param textId
   * @returns {AxiosPromise}
   */
  deleteRouteText(routeId, textId) {
    return conduit.delete(`routes/route/${routeId}/texts/${textId}`);
  },


  /**
   * @param route
   * @param info
   * @returns {*}
   */
  saveCheckInInformationForRoute(route, info) {
    return conduit.put(`routes/route/${route.id}/check-in-information`, info);
  },

  /**
   * Retrieve route areas.
   *
   * @param route
   * @returns {*}
   */
  getRouteAreas(route) {
    if (!route.areaIds.length) {
      return Promise.resolve({ data: [] });
    }
    return conduit.post('twenty/areas/by-area-ids', {
      areaIds: route.areaIds,
    });
  },

  /**
   * @returns AxiosPromise
   */
  getNonDynamicTransports() {
    return conduit.get('routes/non-dynamic-transports');
  },

  /**
   * @param supplier
   * @returns {AxiosPromise}
   */
  getPersonCategoriesBySupplier(supplierId) {
    return conduit.get(`person-categories/suppliers/${supplierId}`);
  },

  /**
   * @param supplierId
   * @param personCategory
   * @returns {AxiosPromise}
   */
  savePersonCategoryBySupplier(supplierId, personCategory) {
    return conduit.put(`person-categories/suppliers/${supplierId}/update`, {
      personCategories: [
        personCategory,
      ],
    });
  },

  /**
   * @param supplierId
   * @param personCategory
   * @returns {AxiosPromise}
   */
  addPersonCategoryBySupplier(supplierId, personCategory) {
    return conduit.post(`person-categories/suppliers/${supplierId}/add`, {
      personCategories: [
        personCategory,
      ],
    });
  },

  /**
   * @param cabin
   * @returns {AxiosPromise}
   */
  updateCabin(cabin) {
    return conduit.put('cabins/update', {
      cabins: [
        cabin,
      ],
    });
  },

  /**
   * @param routeId
   * @param cabin
   * @returns {AxiosPromise}
   */
  addCabinByRoute(routeId, cabin) {
    return conduit.post(`cabins/routes/${routeId}/add`, {
      cabins: [
        cabin,
      ],
    });
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getCabinsByRoute(routeId) {
    return conduit.get(`cabins/routes/${routeId}`);
  },

  /**
   * @param seasonDepartureId
   * @param type
   */
  getCabinsPrices(seasonDepartureId, type) {
    return conduit.get(`seasons/prices/${seasonDepartureId}/type/${type}`);
  },

  /**
   * @param extra
   * @returns {AxiosPromise}
   */
  updateExtra(extra) {
    return conduit.put('extras/update', {
      extras: [
        extra,
      ],
    });
  },

  /**
   * @param routeId
   * @param extra
   * @returns {AxiosPromise}
   */
  addExtraByRoute(routeId, extra) {
    return conduit.post(`extras/routes/${routeId}/add`, {
      extras: [
        extra,
      ],
    });
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getExtrasByRoute(routeId) {
    return conduit.get(`extras/routes/${routeId}`);
  },

  /**
   * @param seasonDepartureId
   */
  getDepartureExtrasPrices(seasonDepartureId) {
    return conduit.get(`seasons/prices/${seasonDepartureId}/type/extra`);
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getFerrySeasonsByRoute(routeId) {
    return conduit.get(`fjordline/seasons/routes/${routeId}`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getFerrySeasonPrices(seasonId) {
    return conduit.get(`fjordline/seasons/${seasonId}/prices`);
  },

  /**
   * @param seasonId
   * @param prices
   * @returns {AxiosPromise}
   */
  saveFerrySeasonPrices(seasonId, prices) {
    return conduit.post(`fjordline/seasons/${seasonId}/prices/save`, prices);
  },

  /**
   * @param season
   * @returns {AxiosPromise}
   */
  updateFerrySeason(season) {
    return conduit.put(`fjordline/seasons/${season.id}/update`, { season });
  },

  /**
   * @param season
   * @returns {AxiosPromise}
   */
  addFjordlineSeason(season) {
    return conduit.post('fjordline/seasons/add', { season });
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getSeasonsByRoute(routeId) {
    return conduit.get(`seasons/route/${routeId}`);
  },

  /**
   * @param season
   * @returns {AxiosPromise}
   */
  addSeason(season) {
    return conduit.post('seasons/add', { season });
  },

  /**
   * @param season
   * @returns {AxiosPromise}
   */
  updateSeason(season) {
    return conduit.put(`seasons/${season.id}/update`, { season });
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getSeasonDepartures(seasonId) {
    return conduit.get(`seasons/prices/season/${seasonId}`);
  },

  /**
   * @param seasonDepartureId
   * @param direction
   * @returns {AxiosPromise}
   */
  getDepartureDays(seasonDepartureId, direction) {
    return conduit.get(`seasons/prices/${seasonDepartureId}/direction/${direction}`);
  },

  addDepartureDay(seasonDepartureId, direction, body) {
    return conduit.post(`seasons/prices/${seasonDepartureId}/direction/${direction}`, body);
  },

  deleteDepartureDay(seasonDepartureId, direction, body) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/direction/${direction}`, body);
  },

  /**
   * @param seasonPrice
   * @returns {AxiosPromise}
   */
  addSeasonDeparture(seasonPrice) {
    return conduit.post('seasons/prices/add', { seasonPrice });
  },

  /**
   * @param seasonDeparture
   * @returns {AxiosPromise}
   */
  updateSeasonDeparture(seasonPrice) {
    return conduit.put(`seasons/prices/${seasonPrice.id}/update`, { seasonPrice });
  },

  /**
   * @param seasonDepartureId
   * @returns {AxiosPromise}
   */
  deleteSeasonDeparture(seasonDepartureId) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/delete`);
  },

  /**
   * @param seasonDepartureId
   * @param body
   * @returns {AxiosPromise}
   */
  updateDeparturePriceCabin(seasonDepartureId, body) {
    return conduit.post(`seasons/prices/${seasonDepartureId}/type/cabin`, { prices: body });
  },

  /**
   * @param seasonDepartureId
   * @returns {AxiosPromise}
   */
  deleteDeparturePriceCabin(seasonDepartureId, body) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/type/cabin`, { ids: body });
  },

  /**
   * @param seasonDepartureId
   * @param body
   * @returns {AxiosPromise}
   */
  updateDeparturePriceExtra(seasonDepartureId, body) {
    return conduit.post(`seasons/prices/${seasonDepartureId}/type/extra`, { prices: body });
  },

  /**
   * @param seasonDepartureId
   * @returns {AxiosPromise}
   */
  deleteDeparturePriceExtra(seasonDepartureId, body) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/type/extra`, { ids: body });
  },

  /**
   * @param priceDay
   * @returns {AxiosPromise}
   */
  createSeasonPriceDay(priceDay) {
    return conduit.post('seasons/prices/days/add', { priceDay });
  },

  /**
   * @param priceDay
   * @returns {AxiosPromise}
   */
  updateSeasonPriceDay(priceDay) {
    return conduit.put(`seasons/prices/days/${priceDay.id}/update`, { priceDay });
  },

  /**
   * @param priceDayId
   * @returns {AxiosPromise}
   */
  deleteSeasonPriceDay(priceDayId) {
    return conduit.delete(`seasons/prices/days/${priceDayId}/delete`);
  },

  /**
   * @param seasonDepartureId
   * @param direction
   * @returns {AxiosPromise}
   */
  getDepartureBlockDays(seasonDepartureId, direction) {
    return conduit.get(`seasons/prices/${seasonDepartureId}/direction/${direction}/block`);
  },

  addDepartureBlockDay(seasonDepartureId, direction, body) {
    return conduit.post(`seasons/prices/${seasonDepartureId}/direction/${direction}/block`, body);
  },

  deleteDepartureBlockDay(seasonDepartureId, direction, body) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/direction/${direction}/block`, body);
  },

};



// WEBPACK FOOTER //
// ./src/services/transportation-service.js